// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar__avatar--+bigq"};